module.exports = __webpack_public_path__ + "img/3.cee1b434.jpg";